import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import StatsBar from "@/components/StatsBar";
import PopularDestinations from "@/components/PopularDestinations";
import WhyChoose from "@/components/WhyChoose";
import TrendingExperiences from "@/components/TrendingExperiences";
import AIPlanner from "@/components/AIPlanner";
import Stories from "@/components/Stories";
import AppDownload from "@/components/AppDownload";
import Partners from "@/components/Partners";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar overlay />
      <main>
        <Hero />
        <StatsBar />
        <PopularDestinations />
        <WhyChoose />
        <TrendingExperiences />
        <AIPlanner />
        <Stories />
        <AppDownload />
        <Partners />
      </main>
      <Footer />
    </div>
  );
}
